<template>
  <v-card class="card" outlined rounded="0">
    <!-- <v-card color="orange lighten-5"> -->
    <!-- <v-card outlined class="card"> -->
    <slot name="image">
    <!-- <v-img src="@/assets/paper.jpg" height="250px"> -->
    <!-- </v-img> -->
    </slot>
    <slot name="iframe">
    </slot>
    <v-card-title>
      <slot>タイトル</slot>
    </v-card-title>
    <v-card-subtitle class="pb-0">
      <slot name="sub">サブタイトル</slot>
    </v-card-subtitle>
    <v-card-actions>
      <v-btn color="orange lighten-2" text @click="show = !show">
        詳細
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn icon @click="show = !show">
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-actions>
    <v-expand-transition>
      <div v-show="show">
        <v-divider></v-divider>
        <v-card-text>
          <slot name="body">--</slot>
        </v-card-text>
      </div>
    </v-expand-transition>
    </v-card>
</template>

<script>
export default {
  data: () => ({
    show: false,
  }),
}
</script>
<style>
.card {
  border-color: #a1887f !important;
  border-width: 2px !important;
  border-style: solid !important;
  margin: 2px !important;
  background-color: #fff3e0 !important;
/*  padding: 2px !important; */
}

</style>
